import { Controller, useFormContext } from "react-hook-form";
import { CustomFormField } from "../../../../../../utilis/component/CustomFormElement";
import { investigationForm } from "../../../../Investigation/fieldData";
import { useMutation } from "react-query";
import {
  getDentalCpt,
  getInsuranceCptRate,
  getInsurancePatientShare,
  SaveDentalProcedure,
} from "../../../../../services";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  InputAdornment,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import usePopup from "../../../../../../hooks/usePopup";
import { useParams } from "react-router-dom";
import { TeethContextV1 } from "../../../indexv1";
import { clinicId } from "../../../../../../constants";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PercentIcon from "@mui/icons-material/Percent";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { defaultValue } from "./Types";
import { EmrContext } from "../../../../..";
import debounce from "../../../../../../utilis/methods/networkHandling";
import { FormOnChangeEventType } from "../../../../../types";
import useAuthentication from "@hooks/useAuthentication";
import useCptFavourite from "../../../../hook/useCptFavourite";
// import { CptCodeType } from "../../../../Procedures/types"
const DentalForm = () => {
  const { control, setValue, getValues, handleSubmit, reset, clearErrors } =
    useFormContext();
  const { user } = useAuthentication();
  const activitySearchUserId =
    Number(user?.userId ?? user?.login_id) || null;
  const { patientData, triggerConsultationStart } = useContext(EmrContext);
  const { encounterId, patientId } = useParams();
  const { CustomModal, showSnackbar } = usePopup();
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState(0);
  const insDiscount = useRef(0);
  const [disable, setDisable] = useState({
    exclude: false,
    approvalRequired: false,
  });
  const oncptChange = (data: FormOnChangeEventType) => {
    setValue(investigationForm?.isExcluded.name, data?.target.value.isExclude);
    setValue(
      investigationForm?.approvalRequired.name,
      data?.target.value.approvalRequired,
    );

    if (patientData?.pmaster?.paymentMode == 1) {
      if (data.target.value.insCoverage == 0 || data?.target.value.isExclude) {
        setShow(true);
      } else {
        handlefetchRate();
        setDisable({ exclude: false, approvalRequired: false });
      }
    } else {
      fetchCashRate();
    }
  };

  const {
    selectedTooth,
    setSelectedTooth,
    setEdit,
    setSaveFlag,
    saveFlag,
    edit,
  } = useContext(TeethContextV1);

  const { mutate: fetchCptRate, isLoading: insRateLoading } = useMutation(
    getInsuranceCptRate,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setValue(investigationForm.Rate.name, result.response.insRate);
          setValue(investigationForm.amount.name, result.response.insRate);
          calculateInsRate();
          setShow(false);
        } else {
          showSnackbar({
            message: "Can't fetch rate",
            open: false,
            variant: "warning",
          });
        }
        setShow(false);
      },
    },
  );

  const { mutate: SaveProcedure, isLoading: saveProcedureLoading } =
    useMutation(SaveDentalProcedure, {
      onSuccess: (data) => {
        if (data.responseIndicator === "success") {
          showSnackbar({
            message: "Dental Procedure Saved Successfully",
            open: true,
            variant: "success",
          });
          setSaveFlag(!saveFlag);
          setSelectedTooth({});
          reset(defaultValue);
          setEdit({});
          getCpt(buildDentalCptParams("a"));
        } else {
          showSnackbar({
            message: "Failed to Save Dental Procedure",
            open: true,
            variant: "error",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Failed to Update",
          open: true,
          variant: "error",
        });
      },
    });

  const { mutate: getCpt, data: cptDetails } = useMutation(getDentalCpt);

  const {
    cptListOpen,
    setCptListOpen,
    renderCptOptionListItem,
  } = useCptFavourite({ cptOptions: cptDetails?.response ?? undefined });

  const buildDentalCptParams = (searchText: string) => ({
    clinicId: Number(user?.clinicId),
    encounterId: parseInt(encounterId as string),
    searchText,
    groupId: 6,
    userGroup: 1,
    userId: activitySearchUserId,
    codetype: String(user?.codetype),
    insname: patientData?.insurancePatient?.insurance_name
      ? String(patientData?.insurancePatient?.insurance_name)
      : null,
  });

  useEffect(() => {
    getCpt(buildDentalCptParams("a"));
  }, []);
  const { mutate: getPatientShare, isLoading: patientShareLoading } =
    useMutation(getInsurancePatientShare, {
      onSuccess: (data) => {
        insDiscount.current = data.response.insDiscount || 0;
        const discountType =
          getValues(investigationForm.discountType.name) || "Percentage";
        let discount = Number(
          getValues(investigationForm.discount.name) || "0",
        );
        let patShare = Number(data.response.patShare || "0");

        if (discount < 0) {
          discount = 0;
          setValue(investigationForm.discount.name, 0);
        } else if (discountType === "Percentage" && discount > 100) {
          discount = 100;
          setValue(investigationForm.discount.name, 100);
        } else if (
          discountType === "Amount" &&
          patShare > 0 &&
          discount > patShare
        ) {
          discount = patShare;
          setValue(investigationForm.discount.name, patShare);
        }
        clearErrors(investigationForm.discount.name);

        if (discountType === "Percentage") {
          patShare = patShare - (patShare * discount) / 100;
        } else {
          patShare = patShare - discount;
          patShare = patShare < 0 ? 0 : patShare;
        }
        setValue(
          investigationForm.amount.name,
          data.response.insAmount.toString(),
        );
        setValue(investigationForm.patientShare.name, patShare.toFixed(2));
        setAmount(data.response.amount);
      },
    });
  const PrepareProcedure = (data: any) => {
    const computeActualPatShare = () => {
      const after = Number(data?.patientshare || 0);
      const discount = Number(data?.discount || 0);
      const discountType = String(data?.discountType || "Percentage").toLowerCase();
      if (discountType === "percentage") {
        const pct = Math.min(Math.max(discount, 0), 100);
        const denom = 1 - pct / 100;
        if (denom <= 0) return 0;
        const base = after / denom;
        return Number.isFinite(base) ? Number(base.toFixed(2)) : 0;
      }
      const base = after + Math.max(discount, 0);
      return Number.isFinite(base) ? Number(base.toFixed(2)) : 0;
    };

    return {
      upperJaw: selectedTooth,
      clinicId: clinicId,
      createdById: Number(user?.userId),
      encounterId: parseInt(encounterId as string),
      createdDate: data.createdDate,
      procedureDetailsDto: {
        clinicId: clinicId,
        procedureId: data.procedureId || null,
        patientId: patientId,
        visitId: parseInt(encounterId as string),
        cptId: data?.cpt.cptId,
        encounterId: parseInt(encounterId as string),
        reason: data.Reason,
        cptGroupId: 6,
        quantity: data.Quantity,
        amount: amount,
        status: 1,
        isApprovalRequired: data.approvalRequired,
        outHouse: 0,
        isDenialCode: null,
        isPerformed: Boolean(data.IsPerfomed),
        isDentalExam: 0,
        isExclude: Boolean(data.isExcluded),
        createdId: 1,
        isBilled: 0,
        insDiscount: insDiscount.current,
        discountType: data.discountType || "Percentage",
        insAmount: data.insAmount || 0,
        pShare: data.patientshare || 0,
        unitRate: data.Rate || null,
        isModified: 0,
        userType: 1,
        nursingProcedure: data.nursingProcedure,
        nursingRemarks: edit?.nursingRemarks || "",
        revertFlag: false,
        actionCode: "ACTION123",
        insCoverage: data.cpt.insCoverage || 0,
        hl7MsgStatus: 0,
        remarks: data?.Remark || data?.doctorRemarks,
        doctorsRemarks: data?.Remark,
        discountAmount:(data.discountType || "Percentage") == "Percentage" ? null : Number(data.discount),
        discountPercentage:(data.discountType || "Percentage") == "Percentage" ? Number(data.discount) : null,
        actualPatshare: computeActualPatShare(),
      },
    };
  };

  const onsubmit = (data: any) => {
    const toothProcedure = PrepareProcedure(data);
    triggerConsultationStart();
    SaveProcedure(toothProcedure);
  };

  const getFormQuantity = () => {
    const quantity = parseFloat(getValues(investigationForm.Quantity.name) || "0");
    if (Number.isFinite(quantity) && quantity > 0) {
      return quantity;
    }
    return Object.entries(selectedTooth).length || 1;
  };

  const calculateInsRate = () => {
    const body = {
      cptId: getValues(investigationForm.cptItem.name)?.cptId,
      amount: getValues(investigationForm.Rate.name),
      qty: getFormQuantity(),
      encounter: parseInt(encounterId as string),
      cptGroupId: 6,
      id: Object.keys(edit).length == 0 ? 0 : 1,
      clinicId: 1,
      editFlag: Object.keys(edit).length == 0 ? 0 : 1,
    };
    getPatientShare(body);
  };

  const quantityChange = () => {
    if (!getValues(investigationForm.cptItem.name)) {
      return;
    }

    if (
      getValues(investigationForm.cptItem.name)?.insCoverage == 0 ||
      getValues(investigationForm.isExcluded.name)
    ) {
      calculateRate();
    } else {
      calculateInsRate();
    }
  };
  const calculateRate = () => {
    const quantity = getFormQuantity();
    const rate = parseFloat(getValues(investigationForm.Rate.name) || "0");
    let discount = Number(getValues(investigationForm.discount.name) || "0");
    const discountType =
      getValues(investigationForm.discountType.name) || "Percentage";
    let total = rate * quantity || 0;
    const originalTotal = total;

    if (discount < 0) {
      discount = 0;
      setValue(investigationForm.discount.name, 0);
    } else if (discountType === "Percentage" && discount > 100) {
      discount = 100;
      setValue(investigationForm.discount.name, 100);
    } else if (discountType === "Amount" && total > 0 && discount > total) {
      discount = total;
      setValue(investigationForm.discount.name, total);
    }
    clearErrors(investigationForm.discount.name);

    if (discountType === "Percentage") {
      total = total - (total * discount) / 100;
    } else {
      total = total - discount;
      total = total < 0 ? 0 : total;
    }
    setAmount(originalTotal);
    setValue(investigationForm.amount.name, originalTotal.toString());
    setValue(investigationForm.patientShare.name, total.toFixed(2));
  };

  useEffect(() => {
    console.log("disable", disable);
  }, [disable]);

  const onExcludeChange = (e: FormOnChangeEventType) => {
    if (e.target.value) {
      setDisable({ exclude: false, approvalRequired: true });
      setShow(true);
    } else {
      setDisable({ exclude: false, approvalRequired: false });
      reset({ ...getValues(), amount: "", patientShare: "", Rate: "" });
      getValues(investigationForm.cptItem.name)?.approvalRequired &&
        setValue(investigationForm.approvalRequired.name, true);
      handlefetchRate();
    }
  };

  const ApprovalRequiredChange = (e: FormOnChangeEventType) => {
    if (e.target.value) {
      setDisable({ exclude: true, approvalRequired: false });
    } else {
      setDisable({ exclude: false, approvalRequired: false });
    }
  };

  const handlefetchRate = () => {
    const cpt_id = getValues(investigationForm.cptItem.name)?.cptId || 0;
    const body = {
      encounter: parseInt(encounterId as string),
      clinicId,
      cptId: cpt_id,
      cptGroupId: 6,
      paymentMode: 1,
    };
    fetchCptRate(body);
  };
  const fetchCashRate = () => {
    setValue(
      investigationForm.Rate.name,
      (
        (getValues(investigationForm.cptItem.name).cptRate as number) || 0
      ).toString(),
    );
    quantityChange();
    setShow(false);
  };

  const onValueChange = (data: any) => {
    getCpt(buildDentalCptParams(data));
  };

  const debouncedFetchData = debounce(onValueChange, 500);
  const selectedToothLength = useMemo(
    () => Object.entries(selectedTooth).length,
    [selectedTooth],
  );
  useEffect(() => {
    const toothno = Object.entries(selectedTooth).map((item: any) => {
      return item[1].toothNo;
    });
    setValue("toothNo", toothno);

    if (Object.keys(edit).length !== 0) {
      const editQuantity = Number(
        (edit as any)?.Quantity ?? (edit as any)?.quantity,
      );
      setValue(
        "Quantity",
        Number.isFinite(editQuantity) && editQuantity > 0
          ? editQuantity
          : selectedToothLength || 1,
      );
      if (Object.values(selectedTooth)?.length !== 0) {
        quantityChange();
      }
    } else {
      setValue("Quantity", selectedToothLength);
      quantityChange();
    }
  }, [selectedToothLength, edit]);
  return (
    <div>
      <CustomModal title="Fetch rate" open={show} setOpen={setShow}>
        <div className="w-[40vw]">
          <div className="h-[10dvh] p-4">
            <Typography>Do you want to fetch Cash rate ?</Typography>
          </div>
          <div className="p-3 flex justify-end gap-3 border-t">
            <Button
              color="error"
              onClick={() => {
                setShow(false);
                if (getValues(investigationForm.isExcluded.name) === true) {
                  setValue(investigationForm.isExcluded.name, false);
                  calculateInsRate();
                }
              }}
            >
              no
            </Button>
            <Button
              onClick={() => {
                reset({
                  ...getValues(),
                  amount: "",
                  patientShare: "",
                  Rate: "",
                  approvalRequired: false,
                });
                fetchCashRate();
                setDisable({ exclude: false, approvalRequired: true });
              }}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <form action="" onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-12 gap-2 m-2">
          <div className="col-span-6">
            <CustomFormField
              control={control}
              name="cpt"
              fieldProps={{
                label: "Enter cpt details",
                onChange: (e) => {
                  debouncedFetchData(e.target.value);
                },
              }}
              element="autocomplete"
              options={cptDetails?.response || []}
              rules={{ required: "cpt required", onChange: oncptChange }}
              autocompleteProps={{
                open: cptListOpen,
                onOpen: () => setCptListOpen(true),
                onClose: () => setCptListOpen(false),
                filterOptions: (option) => option,
                isOptionEqualToValue: (option, value) => {
                  return option.cptId == value.cptId;
                },
                getOptionLabel: (option) =>
                  `${option.cptCode} [${option.cptName}]`,
                renderOption: (props, option) =>
                  renderCptOptionListItem(
                    props,
                    option,
                    <div className="grid grid-cols-12 w-full gap-2">
                      <div className="col-span-3 flex items-start justify-start gap-1 min-w-0">
                        <div className="w-5 flex-shrink-0">
                          {option.insCoverage == 1 && (
                            <VerifiedUserIcon
                              color="success"
                              sx={{ fontSize: "1.2rem" }}
                            />
                          )}
                        </div>
                        <strong>Code :</strong>
                        <Typography noWrap sx={{ minWidth: 0 }}>
                          {option.cptCode}
                        </Typography>
                      </div>
                      <div className="col-span-4 flex gap-1 border-s-2 ps-2 min-w-0">
                        <strong>Description:</strong>
                        <Typography noWrap sx={{ minWidth: 0, flex: 1 }}>
                          {option.cptDes}
                        </Typography>
                      </div>
                      <div className="col-span-5 flex gap-1 border-s-2 ps-2 items-center min-w-0">
                        <strong>Name:</strong>
                        <Typography noWrap sx={{ minWidth: 0, flex: 1 }}>
                          {option.cptName}
                        </Typography>
                      </div>
                    </div>,
                  ),
              }}
            ></CustomFormField>
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.Rate}
              rules={{
                ...investigationForm.Rate.rules,
                onChange: quantityChange,
              }}
              fieldProps={{
                ...investigationForm.Rate.fieldProps,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {insRateLoading && <CircularProgress size={18} />}
                    </InputAdornment>
                  ),
                },
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.Quantity}
              rules={{
                ...investigationForm.Quantity.rules,
                onChange: quantityChange,
              }}
              fieldProps={{
                ...investigationForm.Quantity.fieldProps,
                inputProps: { min: 1 },
                onKeyDown: (e: any) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+") {
                    e.preventDefault();
                  }
                },
              }}
            />
          </div>
          <div className="col-span-2 flex">
            <CustomFormField
              control={control}
              {...investigationForm.discount}
              fieldProps={{
                ...investigationForm.discount.fieldProps,
                onKeyDown: (e: any) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+") {
                    e.preventDefault();
                  }
                },
                onInput: (e: any) => {
                  let val = Number(e.target.value);
                  const discountType =
                    getValues(investigationForm.discountType.name) ||
                    "Percentage";
                  if (val < 0) {
                    e.target.value = "0";
                  } else if (discountType === "Percentage" && val > 100) {
                    e.target.value = "100";
                  }
                },
                inputProps: { min: 0 },
                sx: {
                  fontSize: "0.875rem",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                  "&.MuiOutlinedInput-root": {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  },
                  "& .MuiSelect-select": {
                    paddingX: "4px",
                  },
                },
                onChange: quantityChange,
              }}
              rules={{
                ...investigationForm.discount.rules,
                onChange: quantityChange,
              }}
            />
            <Controller
              control={control}
              name={investigationForm.discountType.name}
              rules={{ required: false, onChange: quantityChange }}
              render={({
                field: { ref, onChange, value = "Percentage", ...field },
              }) => (
                <Select
                  {...field}
                  size="small"
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    quantityChange();
                  }}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    fontSize: "0.875rem",
                    height: "100%",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: "none",
                    },
                    "&.MuiOutlinedInput-root": {
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: "none",
                    },
                    "& .MuiSelect-select": {
                      paddingY: "8.5px",
                      paddingX: "4px",
                      borderLeft: "none",
                    },
                  }}
                >
                  <MenuItem value={"Percentage"}>
                    <PercentIcon fontSize="small" />
                  </MenuItem>
                  <MenuItem value={"Amount"}>
                    {/* <AttachMoneyIcon fontSize="small" /> */}
                    AMT.
                  </MenuItem>
                </Select>
              )}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.amount}
              fieldProps={{
                ...investigationForm.amount.fieldProps,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {insRateLoading ||
                        (patientShareLoading && <CircularProgress size={18} />)}
                    </InputAdornment>
                  ),
                },
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.patientShare}
              fieldProps={{
                ...investigationForm.patientShare.fieldProps,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {insRateLoading ||
                        (patientShareLoading && <CircularProgress size={18} />)}
                    </InputAdornment>
                  ),
                },
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="checkbox"
              fieldProps={{ label: "Nursing Procedure" }}
              name="nursingProcedure"
              rules={{ required: false }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="checkbox"
              name="approvalRequired"
              rules={{
                required: false,
                onChange: () => ApprovalRequiredChange,
              }}
              fieldProps={{ label: "Approval required " }}
              checkboxProps={{
                label: "Approval required ",
                disabled: Boolean(patientData?.pmaster?.paymentMode)
                  ? Boolean(
                      getValues(investigationForm.cptItem.name)?.insCoverage,
                    )
                    ? disable.approvalRequired
                    : true
                  : true,
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.IsPerfomed}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.isExcluded}
              fieldProps={{ ...investigationForm.isExcluded.fieldProps }}
              rules={{
                ...investigationForm.isExcluded.rules,
                onChange: onExcludeChange,
              }}
              checkboxProps={{
                disabled: Boolean(patientData?.pmaster?.paymentMode)
                  ? Boolean(
                      getValues(investigationForm.cptItem.name)?.insCoverage,
                    )
                    ? disable.exclude
                    : true
                  : true,
                label: "Exclude",
              }}
            />
          </div>
          <div className="col-span-2">
            <Tooltip
              title={getValues("toothNo")?.join(", ") || ""}
              arrow
              placement="left"
            >
              <div>
                <CustomFormField
                  control={control}
                  element="input"
                  name="toothNo"
                  fieldProps={{ label: "Tooth No" }}
                  rules={{ required: "Tooth Number Required" }}
                />
              </div>
            </Tooltip>
          </div>
          <div className="col-span-2">
            <CustomFormField control={control} {...investigationForm.Reason} />
          </div>
          <div className="col-span-2">
            <CustomFormField control={control} {...investigationForm.Remark} />
          </div>

          <div className="col-span-2 flex gap-2 justify-center items-center">
            <Button
              type="submit"
              color="success"
              endIcon={saveProcedureLoading && <CircularProgress size={18} />}
            >
              Save
            </Button>
            <Button
              color="error"
              onClick={() => {
                reset(defaultValue);
                setEdit({});
                setSelectedTooth({});
              }}
            >
              cancel
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DentalForm;
